module.exports = __webpack_public_path__ + "static/bathroom-316220a52efabca546b1255e3b3c7d14.jpg";